import React from 'react';
import { colors, type, space, engagementLevel } from '../tokens';

const STEPS = [
  { label: 'Cold',      color: colors.engagement.cold },
  { label: 'Luke-warm', color: colors.engagement.luke },
  { label: 'Warm',      color: colors.engagement.warm },
  { label: 'Hot',       color: colors.engagement.hot },
  { label: 'On Fire',   color: colors.engagement.onFire },
];

const EngagementGauge = ({ score = 0, showLabel = true, size = 'md' }) => {
  const level = engagementLevel(score);
  const isSm = size === 'sm';
  const segH = isSm ? 6 : 8;
  const segW = isSm ? 14 : 22;
  const gap = isSm ? 3 : 4;

  return (
    <div
      title={`${level.label} — engagement ${score}/100`}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: space[1],
      }}
    >
      {showLabel && (
        <div style={{ display: 'flex', alignItems: 'center', gap: space[2] }}>
          <span style={{ ...type.label, color: colors.textTertiary }}>Engagement</span>
          <span style={{
            ...type.small,
            fontWeight: 700,
            color: level.color,
          }}>
            {level.label}
          </span>
        </div>
      )}
      <div
        role="meter"
        aria-valuenow={score}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`Engagement ${level.label} (${score} of 100)`}
        style={{ display: 'flex', gap }}
      >
        {STEPS.map((step, i) => {
          const active = i <= level.step;
          return (
            <div
              key={step.label}
              title={step.label}
              style={{
                width: segW,
                height: segH,
                borderRadius: 2,
                background: active ? step.color : colors.surfaceInk,
                border: active ? 'none' : `1px solid ${colors.border}`,
                boxShadow: active && i === level.step ? `0 0 0 2px ${step.color}33` : 'none',
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default EngagementGauge;
